<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col>
          <v-row no-gutters>
            <v-col class="d-flex mb-1">
              <v-btn class="mx-2" color="secondary" small @click="refreshSearch"
                ><v-icon>{{mdiRefresh}}</v-icon>{{ $t("label.refresh") }}</v-btn
              >
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-tabs background-color="#009964" center-active dark v-model="tab">
            <v-tab key="couponTab1">{{ $t("label.all") }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item key="couponTab1">
              <v-card flat>
                <v-data-table
                  :headers="couponHeaders"
                  :items="coupons"
                  item-key="DistID"
                  :server-items-length="totalCoupons"
                  :options.sync="options"
                  class="elevation-1"
                >
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiRefresh } from '@mdi/js'
import i18n from "../lang/lang";
import { SearchMemberCoupon } from "@/api/publicServices";
export default {
  metaInfo: {
    title: "優惠券",
    titleTemplate: "%s | 控制台 | 青蛙集運",
  },
  data: () => ({
    title: "label.coupon",
    tab: null,
    coupons: [],
    totalCoupons: 0,
    options: {
      pageSize: 10,
      pageNum: 1,
      sortBy: ["StartDate"],
      sortDesc: [true],
    },

    // svg icons
    mdiRefresh,
  }),
  components: {},
  methods: {
    async refreshSearch() {
      try {
        let data = {};
        data.pageSize = this.options.itemsPerPage;
        data.pageNum = this.options.page;
        data.sortBy = this.options.sortBy;
        data.sortDesc = this.options.sortDesc;
        const response = await SearchMemberCoupon(data);
        this.coupons = response.data.Results;
        this.totalCoupons = response.data.Total;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    couponHeaders() {
      return [
        { text: i18n.t("label.name"), value: "CouponName", sortable: false },
        { text: i18n.t("label.origin"), value: "OriginCountryName" },
        { text: i18n.t("label.destination"), value: "DestCountryName" },
        { text: i18n.t("label.start_date"), value: "StartDate" },
        { text: i18n.t("label.end_date"), value: "EndDate" },
        { text: i18n.t("label.status"), value: "Status" },
      ];
    },
  },
  mounted() {
    this.refreshSearch();
  },
  watch: {
    options: {
      handler() {
        this.refreshSearch();
      },
      deep: true,
    },
  },
};
</script>
